export function getPagesRoutes() {
  return [
    {
      path: "/pages",
      name: "pages",
      component: () => import(/* webpackChunkName: pages-old-backend */ "./components/PagesOld.vue"),
    },
  ]
}
